import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { customerActions } from "../../../../reducers/customer";
import { IPaginationState } from "../../../../hooks/usePagination";
import { APIAccounts } from "../../../../api";

export const useFetchCustomerNotes = (
  id: number,
  pagination: IPaginationState
): (() => Promise<void>) => {
  const dispatch = useDispatch();
  return useCallback(async () => {
    try {
      dispatch(customerActions.fetchNotesRequest());
      const { data } = await APIAccounts.getAccountNotesRequest(id, {
        page: pagination.page,
        pageSize: pagination.limit,
      });
      dispatch(
        customerActions.fetchNotesSuccess({
          notes: data.rows,
          count: data.count,
          countActive: data.countActive,
        })
      );
      pagination.setCount(data.count);
    } catch (error) {
      console.error("Error handle getAccountNotesRequest", error);
      dispatch(customerActions.fetchNotesFailed());
    }
  }, [pagination.page, pagination.limit]);
};

export const useFetchSuspiciousNotes = (
  id: number,
  pagination: IPaginationState
): (() => Promise<void>) => {
  const dispatch = useDispatch();

  return useCallback(async () => {
    try {
      dispatch(customerActions.fetchSuspiciousNotesRequest());
      const { data } = await APIAccounts.getAccountSuspiciousNotesRequest(id, {
        page: pagination.page,
        pageSize: pagination.limit,
      });
      pagination.setCount(data.count);
      dispatch(
        customerActions.fetchSuspiciousNotesSuccess({
          notes: data.rows,
          count: data.count,
          countActive: data.countActive,
        })
      );
    } catch (error) {
      console.error("Error handle suspicious notes", error);
      dispatch(customerActions.fetchSuspiciousNotesFailed());
    }
  }, [pagination.page, pagination.limit]);
};
